/**
 * Created by zhengyongbo on 17/8/17.
 */

export default {
  login:false,
  openid:undefined,
  telNumber:undefined,
  companyList:[],
  authReady:false,
  menuCollapse: false
}
